/**
 * Maps i18n language codes to date-fns locales.
 * Add new locales here when adding language support.
 */
import type { Locale } from 'date-fns'
import { de, enUS } from 'date-fns/locale'

const dateFnsLocales: Record<string, Locale> = {
  en: enUS,
  de,
}

/**
 * Gets the date-fns locale for a given i18n language code.
 * Falls back to English if the language is not supported.
 */
export function getDateFnsLocale(language: string): Locale {
  return dateFnsLocales[language] ?? enUS
}
